import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-form-delete-plan',
    template: '',
})
export class FormDeletePlanComponent implements OnInit {

    constructor(private router: Router) {
    }

    ngOnInit(): void {
        this.router.navigate(['/app/user/plan'], {queryParams: {action: 'churn'}});
    }
}
